import React, { useState, useEffect } from "react";
import "./style.css";
import Header from "../../../componente/header";
import Paginacao from "../../../componente/paginacao";
import Impressora from "../../../assets/Impressora.png";
import api from "../../../services/api";
import LoadingScreen from "../../../componente/aguarde";
import { podeImprimir } from "../../../componente/permissoes";

const API_URL = "v1/relatorio";
const AUTOCOMPLETE_URL = "v1/relatorio/filtro";

const RelFichaCobrar = () => {
  const [abusca, setabusca] = useState("");
  const [offset, setOffset] = useState(0);
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtcidade, setedtcidade] = useState("0");
  const [lista, setlista] = useState([]);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listacidade, setlistacidade] = useState([]);
  const [qtdetotalpag, setqtdetotalpag] = useState(0);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputValue2, setInputValue2] = useState("");

  const { DateTime } = require("luxon");

  const dt = new Date();

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const handleEquipeSelecionado = (equip) => {
    setInputValue(equip.descricao);
    setedtcodequipe(equip.codequipe);
    setlistaequipe([]);
  };

  const handleCidadeSelecionado = (cid) => {
    setInputValue2(cid.cidade);
    setedtcidade(cid.cidade);
    setlistacidade([]);
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaequipe(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistaequipe([]);
      setedtcodequipe(0);
    }
  };

  const handleInputChange2 = async (e) => {
    const value = e.target.value;
    setInputValue2(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/cidade`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistacidade(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistacidade([]);
      setedtcidade("0");
    }
  };

  const imprimir = async () => {
    setLoading(true);

    try {
      const response = await api.get(`v1/impressoes/relfichacobradas`, {
        responseType: "arraybuffer",
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          cidade: edtcidade,
          usuario: localStorage.getItem("tempUsuario"),
          dt1,
          dt2,
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  const fetchListar = async () => {
    try {
      const response = await api.get(`${API_URL}/fichacobradas`, {
        params: {
          busca: abusca,
          offset,
          codequipe: edtcodequipe,
          cidade: edtcidade,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setlista(response.data);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    }
  };

  useEffect(() => {
    fetchListar();
  }, [abusca, offset, edtcidade, edtcodequipe, dt1, dt2]);

  const fetchListarPaginas = async () => {
    try {
      const response = await api.get(`${API_URL}/fichacobradas/pagtotal4`, {
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          cidade: edtcidade,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setqtdetotalpag(response.data.paginatotal);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    }
  };

  useEffect(() => {
    fetchListarPaginas();
  }, [lista]);

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
          .plus({ hours: 3 })
          .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <h1 className="ms-4">Relatório de Ficha Cobradas</h1>
          <p className="ms-4">
            Rotina para listar todas as fichas cobradas, com a opção de filtrar
            por cidade, equipe e data de lançamento.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <label className="form-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, nome ou cpf"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => {
                setabusca(e.target.value);
                setOffset(0);
              }}
            />
          </div>

          <div className="col-xl-1 col-lg-3 col-md-3 col-sm-3">
            <label htmlFor="periodo" className="form-label">
              Lançamento de...
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt1}
              onChange={(e) => setdt1(e.target.value)}
            />
          </div>

          <div className="col-xl-1 col-lg-3 col-md-3 col-sm-3">
            <label htmlFor="periodo" className="form-label">
              Para...
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt2}
              onChange={(e) => setdt2(e.target.value)}
            />
          </div>

          <div className="col-xl-3 col-lg-5 col-md-5 col-sm-5">
            <label htmlFor="equipe" className="form-label">
              Equipe
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue}
              onChange={handleInputChange}
            />
            <ul className="autocomplete-list">
              {listaequipe.map((equipe) => (
                <li
                  key={equipe.codequipe}
                  onClick={() => handleEquipeSelecionado(equipe)}
                >
                  {equipe.descricao}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <label htmlFor="cidade" className="form-label">
              Cidade
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue2}
              onChange={handleInputChange2}
            />
            <ul className="autocomplete-list">
              {listacidade.map((cid) => (
                <li
                  key={cid.cidade}
                  onClick={() => handleCidadeSelecionado(cid)}
                >
                  {cid.cidade}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-sm-1 d-flex justify-content-center">
            <button className="btn" onClick={imprimir} disabled={!podeImprimir("/relatorio/fichacobradas")}>
              <img src={Impressora} alt="Imprimir" />
              <label>Imprimir</label>
            </button>
            {loading && <LoadingScreen />}
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="col-sm-12 table table-hover">
            <thead>
              <tr>
                <th className="codigo">Cód. Cliente</th>
                <th className="whatsapp">Nome</th>
                <th className="whatsapp">Líquido</th>
                <th className="whatsapp">Moeda</th>
                <th className="lancamento">Dia que vendeu</th>
                <th className="vencimento">Dia para cobrar</th>
                <th className="lancamento">Dia que pagou</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((item) => (
                <tr key={item.codcontasreceber}>
                  <th>{item.codcliente}</th>
                  <th>{item.nome}</th>
                  <th>{parseFloat(item.vlliquido).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</th>
                  <th>{item.moeda}</th>
                  <th>{FormataDataHora(item.dtlancamento)}</th>
                  <th>{FormataData(item.dtvencimento)}</th>
                  <th>{FormataDataHora(item.dtbaixa)}</th>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2">Quantidade de linhas: {lista.length}</td>
                <td colSpan="5">
                  Total:{" "}{lista.reduce((total, item) => total + parseFloat(item.vlliquido), 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row d-flex justify-content-center">
          <Paginacao
            limit={20}
            total={qtdetotalpag}
            offset={offset}
            setOffset={setOffset}
          />
        </div>
      </div>
    </>
  );
};

export default RelFichaCobrar;
